import React from 'react'
import styled from 'styled-components'

const PrimaryButton = ({ text, iconLeft, iconRight, leftIconStyle, rightIconStyle, children, ...props }) => {
    return (
        <ButtonContainer {...props}>
            {iconLeft && <IconWrapper style={leftIconStyle}>{iconLeft}</IconWrapper>}
            {text ? text : children}
            {iconRight && <IconWrapper style={rightIconStyle}>{iconRight}</IconWrapper>}

        </ButtonContainer>
    )
}

export default PrimaryButton
const ButtonContainer = styled.button`
border-radius:4px;
display:flex;
align-items:center;
justify-content:center;
padding:7.5px 16px;
color:${({ theme }) => theme.primaryButton.color};
background:${({ theme }) => theme.primaryButton.background};
border:1px solid ${({ theme }) => theme.primaryButton.borderColor};
gap:10px;
font-weight: 500;
font-size: 14px;
line-height: 100%;
letter-spacing: 0.04px;
cursor:pointer;

&:disabled{
opacity:0.4;
cursor:not-allowed;
}
`

const IconWrapper = styled.span`
    display: flex;
    align-items: center;
`